import { QuestionPagination } from './QuestionPagination';
export default QuestionPagination;
